import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import Roles from '@/features/rbac'

export const Route = createFileRoute('/_authenticated/roles')({
  component: () => (
    <RequirePermission permission='roles.read'>
      <Roles />
    </RequirePermission>
  ),
})
